export enum ApiPathMain {
  AUTHENTICATE_BY_TOKEN = 'auth/authenticate-by-token',
  SIGN_IN = 'auth/signIn',
  AUTH_REFRESH = 'auth/refresh',
  SIGN_UP_VIA_QUIZ = 'funnel/quiz/user',
  SIGN_UP_VIA_EXTERNAL = 'funnel/user/external',
  USER_PROFILE = 'user',
  USER_ACCOUNT = 'user/account',
}

export enum ApiPathAskGateway {
  GENERATE_AUTH_TOKEN = 'auth-token/web/generate',
  EMAIL_VALIDATE = 'email-manager/email/validate',
  LOCALE = 'locale',
  CHAT_MESSAGE_CHATS = 'chat-message/chats',
  ACCOUNT_EXISTS = 'account-auth/account/exists',
  ACCOUNT_EMAIL = 'account-auth/account/email',
  REQUEST_RESET_PASSWORD = 'account-auth/request-reset-password',
  ZENDESK_SUPPORT_FORMS_SUBMIT = 'zendesk/support-forms/submit',
  SPLIT_TESTS_BY_USER_ID = 'split-tests/by-user-id',
  SPLIT_TESTS_BY_SPLIT_ID = 'split-tests/by-split-id',
  HOROSCOPE_ZODIAC = 'horoscope/zodiac',
  ASTROLOGERS_DISCOVERY_OPEN = 'expert-dealer/open/astrologers/discovery',
  ASTRO_CRM_ASTROLOGERS_OPEN = 'astro-crm-service/open/astrologers',
  ASTRO_CRM_REVIEWS_OPEN = 'astro-crm-service/open/reviews',
  NATAL_CHART = 'natal-chart/calculator',
  USER_PROFILE_UPDATE = 'users/me',
  NOTIFICATION_CONSENT_EMAIL = 'notification/consent/email',
  SNITCHER_EVENT = 'snitcher/event',
}
